export enum TimelineEventStatus {
    Upcoming = 0,
    InProgress = 1,
    Completed = 2,
    Late = 3,
}

export const TimelineEventStatuses = [
    { id: TimelineEventStatus.Upcoming, name: 'Upcoming' },
    { id: TimelineEventStatus.InProgress, name: 'In Progress' },
    { id: TimelineEventStatus.Late, name: 'Late' },
    { id: TimelineEventStatus.Completed, name: 'Completed' },
];

export const TimelineEventsTransitions = new Map([
    [
        TimelineEventStatus.Upcoming,
        new Set([
            TimelineEventStatus.Upcoming,
            TimelineEventStatus.InProgress,
            TimelineEventStatus.Completed,
        ]),
    ],
    [
        TimelineEventStatus.InProgress,
        new Set([
            TimelineEventStatus.InProgress,
            TimelineEventStatus.Completed,
        ]),
    ],
    [
        TimelineEventStatus.Late,
        new Set([TimelineEventStatus.Late, TimelineEventStatus.Completed]),
    ],

    [TimelineEventStatus.Completed, new Set([TimelineEventStatus.Completed])],
]);

export const TimelineEventStatusesColorCode = [
    { id: TimelineEventStatus.Upcoming, color: '#a1a1a1' },
    { id: TimelineEventStatus.InProgress, color: '#1e8c1c' },
    { id: TimelineEventStatus.Late, color: '#d92550' },
    { id: TimelineEventStatus.Completed, color: '#333' },
];
